import { Tab, useRecordContext } from "react-admin";
import { hasScope, SCOPE } from "../lib/auth";
import { JsonView } from "./jsonView";

const CustomTab = (props) => {
  const record = useRecordContext();

  if (!hasScope(SCOPE.DIAGNOSTICS)) {
    return null;
  }

  return (
    <Tab label="Custom" {...props}>
      <JsonView data={record?.custom} />
    </Tab>
  );
};

export { CustomTab };
